import { ResourceModel } from '@bryntum/schedulerpro';
import { camelCase } from 'lodash';
import { User } from 'api/models';
import { fullName } from 'utils/full-name';
import { SchedulerResourceType } from '../resource-types';
import { AvailabilityFilter } from '../types';

type SearchFunction = (resource: ResourceModel) => boolean;

export const isMatchingResource = (searchText: string): SearchFunction => {
  const text = searchText.toLowerCase();

  return (resource: ResourceModel): boolean => {
    const type = resource.get('type');

    if (type === SchedulerResourceType.User) {
      const firstName = resource.get('firstName');
      const lastName = resource.get('lastName');

      return fullName({ firstName, lastName }).toLowerCase().includes(text);
    }

    if (type === SchedulerResourceType.Project) {
      const projectName = resource.get('projectName');

      return projectName.toLowerCase().includes(text);
    }

    if (type === SchedulerResourceType.Team) {
      const projectName = resource.get('projectName') ?? '';
      const teamName = resource.get('teamName');

      return (
        projectName.toLowerCase().includes(text) ||
        teamName.toLowerCase().includes(text)
      );
    }
    if (type === SchedulerResourceType.Company) {
      const companyName = resource.get('companyName');

      return companyName.toLowerCase().includes(text);
    }

    return false;
  };
};

export const checkResourceAvailability = (
  resource: ResourceModel,
  availabilityFilter?: AvailabilityFilter,
  availableResources?: number[],
): boolean => {
  switch (resource.get('type')) {
    case SchedulerResourceType.ExpandableRole:
    case SchedulerResourceType.Team:
      return availabilityFilter == null;
    case SchedulerResourceType.User: // project and assignProject wont be needed here as its handled at consumption itself
      return (
        availabilityFilter == null ||
        availableResources == null ||
        availableResources.includes(resource.get('userId'))
      );
    default:
      return true;
  }
};

export const userAsFilterFormat = (user: User): Record<string, unknown> => ({
  ...user,
  role: user.role?.roleId,
  companyId: user.company.companyId,
  ...(user.fields ?? []).reduce((fieldMap, field) => {
    return {
      ...fieldMap,
      [camelCase(field.fieldName)]: field.fieldValue,
    };
  }, {}),
});
